import type moment from 'moment-timezone'

export const getWeekDateRange = (now: moment.Moment, weeksOffset: number) => ({
  dateFrom: now.clone().add(weeksOffset, 'week').startOf('isoWeek').toISOString(),
  dateTo: now.clone().add(weeksOffset, 'week').endOf('isoWeek').toISOString(),
})
